(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hero logo drift, smoothed.
   *
   * Phones deliver scroll events unevenly (and resize the screen as the
   * address bar slides away), so moving the logo straight to each scroll
   * position looks choppy. Here:
   *  - sizes are measured once (and again only when the width changes),
   *    never during scrolling;
   *  - the scroll handler only reads the scroll position;
   *  - the logo eases toward its target using elapsed time, so it glides
   *    the same at 60Hz, 90Hz, 120Hz or a stuttering frame rate.
   */
  (function () {
    if (window.amachHeroDrift) return;
    window.amachHeroDrift = true;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var items = [];
    var frame = 0;
    var lastTime = 0;
    var lastWidth = window.innerWidth;
    var headerBottom = 0;
    var passed = null;
    var SMOOTHING_MS = 70; /* higher = softer, lower = snappier */

    function scrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    /* Measure everything once. Never called while scrolling. */
    function measure() {
      var y = scrollY();
      var header = document.querySelector('.section-header');
      headerBottom = header ? header.getBoundingClientRect().bottom : 0;

      items.forEach(function (item) {
        var saved = item.lockup.style.transform;
        item.lockup.style.transform = 'none';
        var heroRect = item.hero.getBoundingClientRect();
        var contentRect = item.content.getBoundingClientRect();
        var lockupRect = item.lockup.getBoundingClientRect();
        item.lockup.style.transform = saved;

        item.top = heroRect.top + y;
        item.bottom = heroRect.bottom + y;
        /* Room left below the logo inside the hero, so it never spills out */
        item.room = Math.max(0, contentRect.bottom - lockupRect.bottom - 24);
      });
      requestTick();
    }

    function collect() {
      items = [];
      document.querySelectorAll('[data-hero-drift]').forEach(function (hero) {
        var lockup = hero.querySelector('[data-hero-lockup]');
        var content = hero.querySelector('.hero__content');
        if (!lockup || !content) return;
        items.push({
          hero: hero,
          lockup: lockup,
          content: content,
          speed: parseFloat(hero.getAttribute('data-hero-drift')) || 0.45,
          top: 0,
          bottom: 0,
          room: 0,
          current: 0,
          target: 0
        });
      });
      measure();
    }

    /* Homepage: once the hero has scrolled under the sticky header,
       bring the small header logo back in. Uses cached numbers only. */
    function revealHeaderLogo(y) {
      var root = document.documentElement;
      var hero = document.querySelector('body.template-index main .hero');
      var next = false;
      if (hero) {
        var bottom = null;
        for (var i = 0; i < items.length; i++) {
          if (items[i].hero === hero) bottom = items[i].bottom;
        }
        if (bottom === null) {
          next = hero.getBoundingClientRect().bottom <= headerBottom + 1;
        } else {
          next = bottom - y <= headerBottom + 1;
        }
      }
      if (next !== passed) {
        passed = next;
        root.classList.toggle('amach-hero-passed', next);
      }
    }

    function tick(time) {
      frame = 0;
      var y = scrollY();
      var dt = lastTime ? Math.min(time - lastTime, 100) : 16;
      lastTime = time;
      var busy = false;

      revealHeaderLogo(y);

      items.forEach(function (item) {
        if (reduceMotion.matches) {
          if (item.current !== 0) {
            item.current = 0;
            item.lockup.style.transform = '';
          }
          return;
        }

        var scrolled = Math.max(0, y - item.top);
        item.target = Math.min(scrolled * item.speed, item.room);

        /* Ease toward the target; the step depends on real elapsed time */
        var gap = item.target - item.current;
        if (Math.abs(gap) < 0.1) {
          item.current = item.target;
        } else {
          item.current += gap * (1 - Math.exp(-dt / SMOOTHING_MS));
          busy = true;
        }
        item.lockup.style.transform = 'translate3d(0, ' + item.current.toFixed(2) + 'px, 0)';
      });

      if (busy) {
        frame = window.requestAnimationFrame(tick);
      } else {
        lastTime = 0;
      }
    }

    function requestTick() {
      if (frame) return;
      frame = window.requestAnimationFrame(tick);
    }

    function onResize() {
      /* Phones fire resize when the address bar shows or hides; only the
         width changing (rotation, window resize) needs a re-measure. */
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      measure();
    }

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', function () {
      window.setTimeout(measure, 250);
    });
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', function () {
      window.setTimeout(collect, 0);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', collect);
    } else {
      collect();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
